import type {MetaContext} from "./apps/app";
import type {Scene} from "phaser";

import {writable, readable} from "svelte/store";
import {AlignGrid} from "@services/alignmentService";


const staticRootPath = window.location.host.startsWith("localhost") ? "/static" : "https://static.supersloth.app";

// Non-game state
export let metaContext = writable<MetaContext | null>(null);
export let staticRoot = readable<string>(staticRootPath);


// Game-related state
export let grid = writable<AlignGrid | null>(null);
export let scene = writable<Scene | null>(null);
export let obstacles = writable<Phaser.Physics.Arcade.Group>();

// The level the player has advanced to
export let currentLevel = writable<number>(0);
// The level that obstacles have been generated up to
export let obstacleGenerationLevel = writable<number>(2);